export class BackButtonClickEventV1Impl {
    constructor() {
        this.prevent = false;
        this.preventDefault = () => {
            this.prevent = true;
        };
        this.isDefaultPrevented = () => this.prevent;
    }
}
export class NavigationFlyoutAdminV1Impl {
    constructor() {
        this.subscribeToBackButton = (onBackButtonClick) => {
            this.onBackButtonClick = onBackButtonClick;
        };
        this.unsubscribeToBackButton = () => {
            this.onBackButtonClick = undefined;
        };
        this.hasBackButtonSubscription = () => Boolean(this.onBackButtonClick);
        this.fireOnBackButtonClick = () => {
            const e = new BackButtonClickEventV1Impl();
            if (this.onBackButtonClick) {
                this.onBackButtonClick(e);
            }
            return e;
        };
    }
}
export class NavigationFlyoutServiceV1Impl {
    constructor(config) {
        this.subscribeToBackButton = (onButtonClick) => {
            this.admin.subscribeToBackButton(onButtonClick);
        };
        this.unsubscribeToBackButton = () => {
            this.admin.unsubscribeToBackButton();
        };
        this.admin = config.admin;
    }
}
